import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ServerErrorsInterceptor } from './server-errors.interceptor';
import { ErrorsHandler } from './errors.handler';

export { ExceptionFactory, FaultDetails, CustomException } from './exception.factory';

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ServerErrorsInterceptor,
            multi: true,
            deps: [ErrorsHandler]
        },
    ]
})
export class ErrorsModule { }
